import { render } from "./CardFocos.vue?vue&type=template&id=4d6d9e6c"
import script from "./CardFocos.vue?vue&type=script&lang=js"
export * from "./CardFocos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__